export const getSimulateDisconnection = (state) => {
  return state.VNTestMode.simulateDisconnection
}

export const getVNDebuggerEnabled = (state) => {
  return state.VNTestMode.VNDebuggerEnabled
}

export const getCardReaderError = (state) => {
  return state.VNTestMode.cardReaderError
}

export const getDebuggerPassthroughEnabled = (state) => {
  return state.VNTestMode.debuggerPassthroughEnabled
}

export const getDebuggerPassthroughMessage = (state) => {
  return state.VNTestMode.debuggerPassthroughMessage
}
